<div class="flex flex-row items-center">
  <img src="assets/svg/geo.svg" class="max-w-4 max-h-4 pr-1" style="filter: invert(71%) sepia(1%) saturate(0%) hue-rotate(358deg) brightness(95%) contrast(88%);">

  <h2 class="line-clamp-1 text-sm font-normal tracking-tightest text-[#A8A8A8]">{{location()}}</h2>
</div>
